<div class="chart-header">
  <div class="label">{{ label | translate }}</div>
  <div class="spacer"></div>
  <div class="actions">
    <ng-container *ngFor="let action of actions">
      <ng-container [ngTemplateOutlet]="action.template" [ngTemplateOutletContext]="{ data: action.data }"></ng-container>
    </ng-container>
  </div>
</div>
<div class="chart-container bar">
  <ngx-charts-bar-vertical-2d [results]="data" [legend]="false" [xAxis]="true" [yAxis]="true" [groupPadding]="4" [roundEdges]="false"> </ngx-charts-bar-vertical-2d>
</div>
